export default __webpack_public_path__ + "static/media/2018 (3).cd4b8779.jpg";